import { render, staticRenderFns } from "./profile-icon.vue?vue&type=template&id=e039af12&scoped=true"
import script from "./profile-icon.vue?vue&type=script&lang=js"
export * from "./profile-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e039af12",
  null
  
)

export default component.exports